import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

class ThemeModeComponent extends BridgeComponent {
    static component = "thememode";

    connect() {
        super.connect();
    }

    // 📲 Called from native with { code: "dark" | "light" }
    thememode() {
        let theme = localStorage.getItem("theme") || "light";
        this.send("thememode", { theme: theme }, (response) => {
            if (theme === "dark") {
                    localStorage.setItem("theme", "dark");
                    document.documentElement.classList.add(
                        "dark",
                        "wkfashion-widget-dark",
                    );
                } else if (theme === "light") {
                    localStorage.setItem("theme", "light");
                    document.documentElement.classList.remove(
                        "dark",
                        "wkfashion-widget-dark",
                    );
                } else {
                    localStorage.setItem("theme", "light");
                    document.documentElement.classList.remove(
                        "dark",
                        "wkfashion-widget-dark",
                    );
                }
        });
    }
}
export default ThemeModeComponent;
